import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { AuthorizationGuard } from './authorization/authorization.guard';
import { ROUTER_PERMISSIONS } from './authorization/router-permissions';
import { ErrorComponent } from './components/error/error.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { NotFound } from './components/not-found/not-found';

export const routes: Routes = [
    {
        path: 'portal',
        component: MsalRedirectComponent,
    },
    {
        path: 'devices/:id/assets',
        loadChildren: () => import('./asset-details/asset-details.module').then((m) => m.AssetDetailsModule),
        data: { permissions: [ROUTER_PERMISSIONS.asset] },
        canActivate: [AuthorizationGuard],
    },
    {
        path: 'not-found',
        component: NotFound,
        canActivate: [MsalGuard],
    },
    {
        path: 'not-authorized',
        component: NotAuthorizedComponent,
        canActivate: [MsalGuard],
    },
    {
        path: 'error',
        component: ErrorComponent,
        canActivate: [MsalGuard],
    },
    {
        path: '',
        loadChildren: () => import('./tenant/tenant.module').then((m) => m.TenantModule),
        data: { permissions: [ROUTER_PERMISSIONS.tenant] },
        canActivate: [AuthorizationGuard],
    },
    {
        path: '**',
        redirectTo: 'not-found',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
            initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
            bindToComponentInputs: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
